/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-28T09:47:56.262Z by lizhutang (lizhutang@spolo.org)

'use strict'

// import absolute from './absolute'

let typeHandler = {}

// absolute(typeHandler)

function proc ({ $content, buildInfo }) {
  let wwtypes = $content.find('[data-wwtype]')
  let PromiseArray = []
  wwtypes.each(function () {
    let $this = $(this)
    let wwtype = $this.attr['data-wwtypes']
    let handler = typeHandler[wwtype]
    if (Function.isFunction(handler)) {
      PromiseArray.push(handler($this, $content, buildInfo))
    } else {
      $this.removeAttr('data-wwtypes')
    }
  })
  return Promise.pipe(PromiseArray)
}

export default proc
